import { render, staticRenderFns } from "./DocumentNameConflictsDialog.vue?vue&type=template&id=03b275e9"
import script from "./DocumentNameConflictsDialog.vue?vue&type=script&lang=js"
export * from "./DocumentNameConflictsDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentNameConflictsDialog.vue?vue&type=style&index=0&id=03b275e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports